import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Page } from '../../../lib/classes/page';
import { ModalComponent } from '../../../lib/services/modal.service';
import {
  ImageService,
  UploadImageResponse,
} from '../../../lib/services/imageService';
import { delay, startWith, take } from 'rxjs/operators';
import { UploadImageType } from '../../../components/upload-image-modal/upload-image-modal.component';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../reducers';
import { HideProgressBar, ShowProgressBar } from '../../../core/actions/layout';
import { Observable } from 'rxjs';

@Component({
  selector: 'mj-unsplash-gallery',
  templateUrl: './mj-unsplash-gallery.component.html',
  styleUrls: ['./mj-unsplash-gallery.component.scss'],
})
export class MjUnsplashGalleryComponent extends ModalComponent
  implements OnInit {
  clientId = '01d26ffed1d2fc06474873a447b67c4e5ed1aca0f36b02865798c991a196a7dc';

  photos: any[];
  loading$: Observable<any>;

  constructor(
    private http: HttpClient,
    private store: Store<fromRoot.State>,
    private imageService: ImageService
  ) {
    super();
    this.data.pipe(take(1)).subscribe((data: any) => {
      this.loadPhotos(data.searchTerm || 'office');
    });
  }

  ngOnInit() {
    this.loading$ = this.store.select(fromRoot.getProgressBarStatus).pipe(
      startWith(null),
      delay(0)
    );
  }

  loadPhotos(term) {
    const params = '&page=1&per_page=1000&orientation=landscape';
    const unsplashApi = 'https://api.unsplash.com/search/photos';
    this.http
      .get<Page<any>>(
        `${unsplashApi}?client_id=${this.clientId}&query=${term}&${params}`
      )
      .subscribe(collection => {
        this.photos = collection.results;
      });
  }

  didClickCloseGallery() {
    this.resolve.next(null);
  }

  didSelectPhoto(photo: any) {
    this.http
      .get<any>(`${photo.links.download_location}?client_id=${this.clientId}`)
      .pipe(take(1))
      .subscribe(url => {
        this.http
          .get<Blob>(url.url, {
            responseType: 'blob' as 'json',
          })
          .pipe(take(1))
          .subscribe(blob => {
            const formData = new FormData();
            formData.append('image', blob, 'test.png');
            formData.append('type', UploadImageType.JOB_TYPE.toString());
            this.imageService
              .uploadImage(formData)
              .pipe(take(1))
              .subscribe((data: UploadImageResponse) => {
                if (data) {
                  this.resolve.next({
                    id: data.id,
                    image: data.image,
                    image_thumbnail: data.image_thumbnail,
                  });
                } else {
                  this.resolve.next(null);
                }
              });
          });
      });
  }
}
